(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["private-sale-gate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('private-sale-gate')) {
    customElements.define('private-sale-gate', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.querySelector('.private-sale-gate__form');
        this.input = this.querySelector('.private-sale-gate__input');
        this.error = this.querySelector('.private-sale-gate__error');
        this.notice = this.querySelector('.private-sale-gate__notice');
        this.prelaunchMessage = this.notice.textContent;
        this.lockedPanel = this.querySelector('.private-sale-gate__locked');
        this.chooserPanel = this.querySelector('.private-sale-gate__chooser');
        this.unlockedPanel = this.querySelector('.private-sale-gate__unlocked');
        this.navigation = this.querySelector('.private-sale-gate__navigation');
        this.navigationLinks = Array.from(this.querySelectorAll('[data-private-sale-nav]'));
        this.priceTemplate = this.querySelector('.private-sale-gate__prices');
        this.priceSources = new Map();

        this.priceTemplate.content.querySelectorAll('[data-private-sale-handle]').forEach((source) => {
          this.priceSources.set(source.dataset.privateSaleHandle, source);
        });

        this.addNoIndexDirective();
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));

        if (!this.isSaleOpen()) {
          this.showPrelaunch();
          return;
        }

        const accessState = sessionStorage.getItem(this.dataset.storageKey);

        if (accessState === 'marketing-unlocked') {
          if (sessionStorage.getItem(this.dataset.discountStorageKey) !== 'applied') {
            this.applyDiscountAndRedirect();
            return;
          }

          this.unlock();
        } else if (accessState === 'unlocked' || accessState === 'pending') {
          if (!this.isSaleOpen()) {
            this.showPrelaunch();
            return;
          }

          sessionStorage.setItem(this.dataset.storageKey, 'unlocked');

          if (sessionStorage.getItem(this.dataset.discountStorageKey) !== 'applied') {
            this.applyDiscountAndRedirect();
            return;
          }

          this.unlock();
        } else {
          document.documentElement.classList.remove('private-sale-unlocked');
          requestAnimationFrame(() => this.input.focus());
        }
      }

      addNoIndexDirective() {
        if (document.head.querySelector('meta[data-private-sale-robots]')) return;

        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex,nofollow,noarchive';
        meta.dataset.privateSaleRobots = 'true';
        document.head.appendChild(meta);
      }

      async handleSubmit(event) {
        event.preventDefault();
        this.error.hidden = true;
        this.notice.hidden = true;

        const candidate = this.input.value.trim().toUpperCase();
        const digest = await this.sha256(candidate);

        if (digest === this.dataset.marketingPasswordHash) {
          sessionStorage.setItem(this.dataset.storageKey, 'marketing-unlocked');
          this.applyDiscountAndRedirect();
          return;
        }

        if (digest === this.dataset.passwordHash) {
          if (!this.isSaleOpen()) {
            this.showPrelaunch();
            return;
          }

          sessionStorage.setItem(this.dataset.storageKey, 'unlocked');
          this.applyDiscountAndRedirect();
          return;
        }

        this.error.hidden = false;
        this.input.select();
      }

      isSaleOpen() {
        const opensAt = Date.parse(this.dataset.opensAt);
        const closesAt = Date.parse(this.dataset.closesAt);
        const now = Date.now();
        const hasStarted = Number.isNaN(opensAt) || now >= opensAt;
        const hasEnded = !Number.isNaN(closesAt) && now > closesAt;

        return hasStarted && !hasEnded;
      }

      showPrelaunch() {
        const closesAt = Date.parse(this.dataset.closesAt);
        const hasEnded = !Number.isNaN(closesAt) && Date.now() > closesAt;

        sessionStorage.setItem(this.dataset.storageKey, 'pending');
        sessionStorage.removeItem(this.dataset.discountStorageKey);
        document.documentElement.classList.remove('private-sale-unlocked', 'private-sale-choosing');
        this.lockedPanel.hidden = false;
        this.chooserPanel.hidden = true;
        this.unlockedPanel.hidden = true;
        this.error.hidden = true;
        this.notice.textContent = hasEnded ? this.dataset.closedMessage : this.prelaunchMessage;
        this.notice.hidden = false;
      }

      async sha256(value) {
        const bytes = new TextEncoder().encode(value);
        const hashBuffer = await crypto.subtle.digest('SHA-256', bytes);
        return Array.from(new Uint8Array(hashBuffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
      }

      applyDiscountAndRedirect() {
        sessionStorage.setItem(this.dataset.discountStorageKey, 'applied');
        window.location.assign(this.dataset.discountUrl);
      }

      unlock() {
        document.documentElement.classList.add('private-sale-unlocked');
        this.lockedPanel.hidden = true;
        this.unlockedPanel.hidden = false;
        this.markCurrentNavigation();

        const url = new URL(window.location.href);
        const shouldChoose = this.dataset.currentCollection === this.dataset.allCollection && url.searchParams.get('selection') !== 'all';

        if (shouldChoose) {
          document.documentElement.classList.add('private-sale-choosing');
          this.unlockedPanel.hidden = true;
          this.chooserPanel.hidden = false;
          return;
        }

        document.documentElement.classList.remove('private-sale-choosing');
        this.unlockedPanel.hidden = false;
        this.chooserPanel.hidden = true;
        this.positionNavigation();
        this.applyPrivatePrices();

        const collectionSection = document.querySelector('.shopify-section--main-collection');

        if (collectionSection) {
          this.observer = new MutationObserver(() => this.applyPrivatePrices());
          this.observer.observe(collectionSection, { childList: true, subtree: true });
        }
      }

      markCurrentNavigation() {
        this.navigationLinks.forEach((link) => {
          if (link.dataset.privateSaleNav === this.dataset.currentCollection) {
            link.setAttribute('aria-current', 'page');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      positionNavigation() {
        const bannerCopy = document.querySelector('.shopify-section--collection-banner .prose');

        if (bannerCopy && this.navigation) {
          bannerCopy.appendChild(this.navigation);
        }
      }

      applyPrivatePrices() {
        document.querySelectorAll('product-card[handle]:not([data-private-sale-priced])').forEach((card) => {
          const inlineSource = card.querySelector('template[data-private-sale-inline-price]');
          const source = this.priceSources.get(card.getAttribute('handle'));
          const currentPrice = card.querySelector('price-list');

          if ((!inlineSource && !source) || !currentPrice) return;

          const priceWrapper = currentPrice.parentElement;
          const sourceNodes = inlineSource ? inlineSource.content.childNodes : source.childNodes;
          priceWrapper.replaceChildren(...Array.from(sourceNodes, (node) => node.cloneNode(true)));

          if (inlineSource && this.dataset.priceNote) {
            const note = document.createElement('p');
            note.className = 'private-sale-price__note';
            note.textContent = this.dataset.priceNote;
            priceWrapper.append(note);
          }
          card.dataset.privateSalePriced = 'true';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
